<ng-container *transloco="let t;">
    <div class="content-wrapper  position-relative p-0">
        <form class="edit-playbook-form card p-2" #form="ngForm" [formGroup]="playbookForm" (ngSubmit)="onSubmit()">

            <!--        guidlenes-->
            <div class="row flex-fill">
                <div class="col-12 flex-fill pe-0">
                    <div class="form-group flex-fill">
                        <div class="row ms-0 me-0  pb-0  mt-2 columns-mapping-container flex-fill">
                            <div class="col-12 ps-0 pe-0  drag-and-drop-container flex-fill">
                                <ng-scrollbar  #guideLineScroll autoHeightDisabled="true" class="flex-fill">

                                    <div class="data-fields-container h-100"
                                         cdkDropList
                                         [cdkDropListData]="guidelines?.controls"
                                         (cdkDropListDropped)="drop($event)">
                                        @for (item of guidelines?.controls; track item; let i = $index) {
                                            <div class="row guideline-item">
                                                <div class="col-12">
                                                    <div class="pe-1 ps-25">
                                                        <div class="data-fields-container-area h-100">
                                                            <div class="data-fields-container example-list h-100" cdkDrag cdkDragLockAxis="y"  [attr.index]="i">
                                                                <app-guideline-tile [formGroup]="item" [submitted]="submitted" (removeGuideline)="removeGuideline(i)"></app-guideline-tile>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        } @empty {
                                            <div class="data-field-list">
                                                <div class="data-field-column-lt text-center w-100">
                                                    {{ t('Empty guideline list notification (edit playbook) - No Guideline has been added') }}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </ng-scrollbar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 d-flex justify-content-between flex-row-reverse">
                    <button type="button" class="btn btn-outline-secondary" [disabled]="hasBlankGuideline" (click)="addNewGuidelineClicked()">
                        {{ t('Add new guideline button name (edit playbook) - Add Guideline') }}
                    </button>
                </div>
            </div>

            <div class="d-flex mt-2">
                <button [disabled]="loading" type="submit" class="btn btn-primary me-50" rippleEffect><span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span> {{t(this.submitButtonTranslationKey)}}</button>
                <button [disabled]="loading" type="reset" class="btn btn-outline-secondary" (click)="closeSiderBar()" rippleEffect>{{t("Cancel button (bulk upload) - Cancel")}}</button>
            </div>
        </form>
    </div>
</ng-container>



<ng-template #errorMessage let-formControl="formControl" let-label="label" let-submitted="submitted">
    <ng-container *transloco="let t;">
        <div *ngIf="submitted && formControl?.invalid" class="invalid-feedback" [ngClass]="{ 'is-invalid': formControl?.invalid }">
            <div *ngIf="formControl.hasError('required')">{{ t('Field required (form validation) - Field name is required', {
                fieldName: label
            }) }}</div>

            <div *ngIf="formControl.hasError('minlength')">
                {{ t('Minimal length (validation message) Minimal length is', {min: formControl.getError('minlength')?.requiredLength}) }}
            </div>
        </div>
    </ng-container>
</ng-template>

